<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="500px"
        transition="slide-y-transition"
        origin="top center"
        eager
        @keydown.esc="onAbort"
        @click:outside="onAbort"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Ustawienie stanowiska
                </h1>
            </v-card-title>

            <div class="mx-5 my-1">
                <v-row>
                    <v-col cols="12">
                        <v-select
                            v-model="workspaceId"
                            :items="workspaces"
                            label="Wybierz stanowisko"
                            item-value="id"
                            item-text="name"
                            outlined
                            hide-details
                            no-data-text="Brak stanowisk"
                            class="mb-6"
                            @input="onSave"
                        />
                    </v-col>
                </v-row>
            </div>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Zamknij"
                    @click="onAbort"
                >
                    Anuluj
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'WorkspaceSettingsDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        isPersistent: {
            type: Boolean
        },
        workspaces: {
            type: Array,
            default: () => []
        },
        workspaceIdData: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            workspaceId: null
        }
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.workspaceId = this.workspaceIdData
            }
        }
    },
    methods: {
        onSave() {
            this.$emit('on-save', this.workspaceId)
        },
        onAbort() {
            this.$emit('on-abort')
            setTimeout(() => {
                this.workspaceId = null
            }, 500)
        },
    }
}
</script>